/**
 * Get user from localStorage with fallback
 * Used when components are loaded as tabs without user prop
 */
export function getUserFromStorage() {
  try {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      return JSON.parse(storedUser);
    }
  } catch (error) {
    console.warn('Failed to get user from storage:', error);
  }
  // Return default user object
  return { 
    role: 'hotel_admin', 
    hotel_id: '', 
    company_id: '',
    name: '',
    email: '' 
  };
}

/**
 * Hook to get user - either from prop or localStorage
 * @param {Object} propUser - User passed as prop
 * @returns {Object} User object
 */
export function useUser(propUser) {
  if (propUser && typeof propUser === 'object' && Object.keys(propUser).length > 0) {
    return propUser;
  }
  return getUserFromStorage();
}

export default getUserFromStorage;
